module.exports = __webpack_public_path__ + "static/media/process 1.6b5db150.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/new/process 1.svg
// module id = 3203
// module chunks = 0